
import { Component } from "vue-property-decorator"
import { BaseApp } from "~/core/Base"
import { ALL_THEME, ACTIVE_THEMES } from "~/constants/theme"
import { CookieHelper } from "~/utils/CookieHelper"
import { ObjectLoader } from "~/loader/object"
import { ILoaderOption } from "~/loader/types"
import { Core } from "~/core/Core"
import { API_TYPE } from "~/constants/apiTypes"
import { LocalStorageHelper } from "~/utils/LocalStorageHelper"

@Component
export default class PlatformSelection extends BaseApp {
  adminEmail = ""

  demoLimitFeature = false
  demoEmail = "demo@pams.ai"

  get activePlatforms(): string {
    return ACTIVE_THEMES
  }

  get allPlatforms(): any[] {
    if (!this.demoLimitFeature) {
      return ALL_THEME
    }
    if (!this.adminEmail) {
      return []
    }
    if (this.adminEmail == this.demoEmail) {
      return ALL_THEME.filter((t) => {
        return t.hide_from_demo === false
      })
    }
    return ALL_THEME
  }

  get authLoader(): ObjectLoader<{ permissions: string[]; token: string }> {
    return new ObjectLoader(
      this,
      (data?: any): ILoaderOption => ({
        apiType: API_TYPE.ECOM,
        baseURL: Core.MKTBACKENDAPI("/me"),
        baseFind: Core.MKTBACKENDAPI("/me"),
        stateKey: "me",

        onFindSuccess: (newValue) => {
          const permissions: object = {}
          for (
            let i = 0;
            i < this.authLoader.findItem.permissions.length;
            i++
          ) {
            permissions[this.authLoader.findItem.permissions[i]] = true
          }
          this.$app.saveToState("me", {
            permissions: permissions,
          })
          LocalStorageHelper.set("me", {
            ...LocalStorageHelper.get("me"),
            ...this.authLoader.findItem,
          })
          const backURL: string = (this.$route.query?.backURL as string) ?? ""
          const token = JSON.parse(CookieHelper.get("me") || "{}")?.["token"]

          if (token) {
            if (backURL) {
              const urlObj = new URL(backURL)
              urlObj.searchParams.set("token", token)
              window.location.href = urlObj.toString()
            } else {
              this.$router.push({
                path: this.$route.query.redirect
                  ? this.$route.query.redirect
                  : "/",
                // path: '/',
              })
            }
          }
        },
        onFindError: (newValue) => {},
      })
    )
  }

  redirect(to) {
    try {
      const urlObj = new URL(to)
      const token = JSON.parse(CookieHelper.get("me") || "{}")?.["token"]
      urlObj.searchParams.set("token", token)
      return urlObj.toString()
    } catch (_) {
      return "/marketing"
    }
  }

  async created() {
    if (!this.demoLimitFeature) {
      return
    }
    this.authLoader.initial()
  }

  async mounted() {
    if (!this.demoLimitFeature) {
      return
    }
    const me = await this.authLoader.$get("")
    this.adminEmail = (this.authLoader.findItem as any).email
  }
}
